import _createClass from "@babel/runtime/helpers/createClass";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";

var _ORIENTATIONS$HORIZON, _ORIENTATIONS$VERTICA, _directionsMap;

import { EventEmitter } from 'eventemitter3';
import { DIRECTIONS, ORIENTATIONS, ANCHOR_POINTS, EVENTS } from '../constants';
var directionsMap = (_directionsMap = {}, _directionsMap[ORIENTATIONS.HORIZONTAL] = (_ORIENTATIONS$HORIZON = {}, _ORIENTATIONS$HORIZON[ANCHOR_POINTS.TOP_LEFT] = DIRECTIONS.STANDARD, _ORIENTATIONS$HORIZON[ANCHOR_POINTS.TOP_RIGHT] = DIRECTIONS.REVERSE, _ORIENTATIONS$HORIZON[ANCHOR_POINTS.BOTTOM_LEFT] = DIRECTIONS.STANDARD, _ORIENTATIONS$HORIZON[ANCHOR_POINTS.BOTTOM_RIGHT] = DIRECTIONS.REVERSE, _ORIENTATIONS$HORIZON), _directionsMap[ORIENTATIONS.VERTICAL] = (_ORIENTATIONS$VERTICA = {}, _ORIENTATIONS$VERTICA[ANCHOR_POINTS.TOP_LEFT] = DIRECTIONS.STANDARD, _ORIENTATIONS$VERTICA[ANCHOR_POINTS.TOP_RIGHT] = DIRECTIONS.STANDARD, _ORIENTATIONS$VERTICA[ANCHOR_POINTS.BOTTOM_LEFT] = DIRECTIONS.REVERSE, _ORIENTATIONS$VERTICA[ANCHOR_POINTS.BOTTOM_RIGHT] = DIRECTIONS.REVERSE, _ORIENTATIONS$VERTICA), _directionsMap);

var CardsConfig = /*#__PURE__*/function (_EventEmitter) {
  _inheritsLoose(CardsConfig, _EventEmitter);

  function CardsConfig() {
    var _this;

    _this = _EventEmitter.call(this) || this;
    _this._orientation = ORIENTATIONS.HORIZONTAL;
    _this._anchorPoint = ANCHOR_POINTS.BOTTOM_LEFT;
    _this._isPreviewMode = false;
    return _this;
  }

  var _proto = CardsConfig.prototype;

  _proto.onChange = function onChange(callback, context) {
    this.on(EVENTS.CONFIG_CHANGED, callback, context);
  };

  _proto.destroy = function destroy() {
    var _this2 = this;

    this.eventNames().forEach(function (eventName) {
      _this2.removeAllListeners(eventName);
    });
  };

  _createClass(CardsConfig, [{
    key: "orientation",
    get: function get() {
      return this._orientation;
    },
    set: function set(value) {
      this._orientation = value;
      this.emit(EVENTS.CONFIG_CHANGED);
    }
  }, {
    key: "anchorPoint",
    get: function get() {
      return this._anchorPoint;
    },
    set: function set(value) {
      this._anchorPoint = value;
      this.emit(EVENTS.CONFIG_CHANGED);
    }
  }, {
    key: "isPreviewMode",
    get: function get() {
      return this._isPreviewMode;
    },
    set: function set(value) {
      this._isPreviewMode = value;
      this.emit(EVENTS.CONFIG_CHANGED);
    }
  }, {
    key: "direction",
    get: function get() {
      var anchorPoint = this.anchorPoint,
          orientation = this.orientation;
      return directionsMap[orientation][anchorPoint];
    }
  }]);

  return CardsConfig;
}(EventEmitter);

export { CardsConfig as default };